/** Top 20 global languages for communication preferences (English UI labels) */

export const PREFERRED_LANGUAGES = [
  { code: 'en', label: '🇺🇸 English' },
  { code: 'zh', label: '🇨🇳 Chinese' },
  { code: 'es', label: '🇪🇸 Spanish' },
  { code: 'ar', label: '🇸🇦 Arabic' },
  { code: 'hi', label: '🇮🇳 Hindi' },
  { code: 'fr', label: '🇫🇷 French' },
  { code: 'pt', label: '🇧🇷 Portuguese' },
  { code: 'ru', label: '🇷🇺 Russian' },
  { code: 'ja', label: '🇯🇵 Japanese' },
  { code: 'de', label: '🇩🇪 German' },
  { code: 'ko', label: '🇰🇷 Korean' },
  { code: 'it', label: '🇮🇹 Italian' },
  { code: 'tr', label: '🇹🇷 Turkish' },
  { code: 'vi', label: '🇻🇳 Vietnamese' },
  { code: 'id', label: '🇮🇩 Indonesian' },
  { code: 'th', label: '🇹🇭 Thai' },
  { code: 'pl', label: '🇵🇱 Polish' },
  { code: 'nl', label: '🇳🇱 Dutch' },
  { code: 'bn', label: '🇧🇩 Bengali' },
  { code: 'zh-tw', label: '🇭🇰 Cantonese' },
]

const LABEL_TO_CODE = Object.fromEntries(PREFERRED_LANGUAGES.map((l) => [l.label, l.code]))

/** Legacy signup tag labels → ISO codes */
const LEGACY_LABEL_MAP = {
  '🇨🇳 Chinese': 'zh',
  '🇺🇸 English': 'en',
  '🇩🇪 German': 'de',
  '🇩🇪 Deutsch': 'de',
  '🇫🇷 French': 'fr',
  '🇫🇷 Français': 'fr',
  '🇪🇸 Spanish': 'es',
  '🇪🇸 Español': 'es',
  '🇭🇰 Cantonese': 'zh-tw',
  '🇸🇦 Arabic': 'ar',
  '🇸🇦 العربية': 'ar',
  '🇯🇵 Japanese': 'ja',
  '🇯🇵 Japanese (legacy tag)': 'ja',
  '🇰🇷 Korean': 'ko',
  '🇰🇷 Korean (legacy tag)': 'ko',
}

export function languageToCode(value) {
  if (!value) return null
  if (PREFERRED_LANGUAGES.some((l) => l.code === value)) return value
  return LABEL_TO_CODE[value] || LEGACY_LABEL_MAP[value] || null
}

export function resolveLanguageCodes(values, max = 3) {
  if (!Array.isArray(values) || !values.length) return ['en']
  const codes = []
  for (const v of values) {
    const code = languageToCode(v)
    if (code && !codes.includes(code)) codes.push(code)
    if (codes.length >= max) break
  }
  return codes.length ? codes : ['en']
}

export function languageLabel(code) {
  return PREFERRED_LANGUAGES.find((l) => l.code === code)?.label || code
}

export function parseDefaultLanguageCode(user) {
  if (!user) return 'en'
  if (user.default_language) {
    const code = languageToCode(user.default_language)
    if (code) return code
  }
  try {
    const meta = JSON.parse(user.registration_notes || '{}')
    if (meta?.defaultLanguage) {
      const code = languageToCode(meta.defaultLanguage)
      if (code) return code
    }
  } catch {
    /* ignore */
  }
  if (Array.isArray(user.preferred_languages) && user.preferred_languages.length) {
    return resolveLanguageCodes(user.preferred_languages, 1)[0]
  }
  return 'en'
}
